const reviews = () => {
  return '/reviews'
}

export default reviews